import Vue from 'vue'
import Router from 'vue-router'
import NotFound from './views/NotFound.vue'
import Ferienwohnung from './views/Ferienwohnung.vue'
import Reservation from './views/Reservation.vue'
import Destination from './views/Destination.vue'
import Start from './views/Start.vue'
import House from './views/House.vue'
import Contact from './views/Contact.vue'
import Faq from './views/Faq.vue'
import Pricing from './views/Pricing.vue'
import About from './views/About.vue'
import Imprint from './views/Imprint.vue'
import PrivacyPolicy from './views/PrivacyPolicy.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'start',
      component: Start,
    },
    {
      path: '/haus',
      name: 'haus',
      component: House,
    },
    {
      path: '/ferienwohnung',
      name: 'ferienwohnung',
      component: Ferienwohnung,
    },
    {
      path: '/ueber-uns',
      name: 'about',
      component: About,
    },
    {
      path: '/die-region',
      name: 'destination',
      component: Destination,
    },
    {
      path: '/belegungen',
      name: 'reservation',
      component: Reservation,
    },
    {
      path: '/faq',
      name: 'faq',
      component: Faq,
    },
    {
      path: '/preise',
      name: 'pricing',
      component: Pricing,
    },
    {
      path: '/kontakt',
      name: 'contact',
      component: Contact,
    },
    {
      path: '/impressum',
      name: 'imprint',
      component: Imprint,
    },
    {
      path: '/datenschutz',
      name: 'privacy-policy',
      component: PrivacyPolicy,
    },
    {
      path: '/not-found',
      name: 'not-found',
      component: NotFound,
    },
    {
      path: '*',
      redirect: { name: 'not-found' },
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})
